<template>
  <div class="content">
    <top-header
      :type="6"
      placeholder="房产法律咨询"
      textColor="#000"
      bgColor="#fff"
      fontSize="0.32rem"
    />
    <div class="flex" style="padding: 0.3rem 0">
      <div class="left">
        <img :src="objData.organLogo" alt="" />
      </div>
      <div class="right">
        <div>事务所:{{ objData.organName }}</div>
        <div>地址:{{ objData.contactAddress }}</div>
        <div>电话:{{ objData.linkPhone }}</div>
      </div>
    </div>
    <div class="flex extend">
      <div class="typeface_grey">团队介绍</div>
      <div class="typeface_black" @click="moreInfo">查看全部>></div>
    </div>
    <div class="dec typeface_greycf">
      {{ objData.bakParam1 }}
    </div>
    <div class="typeface_grey" style="padding: 0.3rem 0">律师团队</div>
    <div class="item_data" v-for="(item, index) in lsList" :key="index">
      <div class="flex extend">
        <div class="flex flex_middle">
          <div class="head_photo">
            <img :src="item.avatar" alt="" />
          </div>
          <div class="">{{ item.userName }}</div>
        </div>
        <div class="flex_middle flex_new">
          <div class="chat" @click="toTalk(item.comment)">
            <img src="@/assets/img/zx.png" alt="" />
          </div>
          <div>线上咨询</div>
        </div>
      </div>
      <div class="dec typeface_grey">
        {{ item.introduction }}
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      objData: {},
      lsList: [],
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.initData();
  },
  methods: {
    moreInfo() {
      this.$router.push({
        path: "/lawyerDetail",
      });
    },
    initData() {
      this.$http
        .post(
          "house/zxgw/zxjgInfo.do",
          qs.stringify({
            type: 0,
          })
        )
        .then((res) => {
          this.objData = res.obj[0];
          this.lsList = res.obj[0].zxgwList;
        });
    },
    toTalk(comment) {
      window.location.href = comment
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  font-size: 0.3rem;
  padding: 0 0.3rem;
  .item_data {
    padding: 0.2rem;
    border-bottom: 3px solid #ccc;
  }
  .typeface_grey {
    color: #808080;
  }
  .typeface_greycf {
    color: #cfcfcf;
  }
  .typeface_black {
    color: #000;
  }
  .head_photo {
    margin-right: 0.3rem;
    width: 0.8rem;
    height: 0.8rem;
    img {
      border-radius: 50%;
      width: 100%;
      height: 100%;
    }
  }
  .chat {
    width: 0.6rem;
    height: 0.6rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .flex_new {
    display: flex;
    flex-direction: column;
  }
  .flex_middle {
    align-items: center;
  }
}
.left {
  width: 40%;
  img {
    width: 80%;
  }
}
.right {
  width: 60%;
  div {
    line-height: 0.6rem;
  }
}
.flex {
  display: flex;
}
.extend {
  justify-content: space-between;
  padding: 0.2rem 0;
}
.dec {
  line-height: 0.5rem;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>